<protctw-sidebar [links]="sidebarNavigationLinks$ | async" />
